import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconFilter = props => (
  <SvgIcon {...props} viewBox="0 0 18 13.9998">
    <path d="m7 14h4v-2.3333h-4v2.3333zm-7-14v2.3333h18v-2.3333h-18zm3 8.1668h12v-2.3333h-12v2.3333z" />
  </SvgIcon>
);

export default IconFilter;



// WEBPACK FOOTER //
// ./src/components/icons/IconFilter.js